export default __webpack_public_path__ + "static/media/all.3b0b966b.png";